const baseEnvironment = process.env.REACT_APP_API_BASE_URL?.trim() || 'http://localhost:8010';
const API_BASE = baseEnvironment.replace(/\/$/, '');

const buildHeaders = () => {
  const token = sessionStorage.getItem('authToken');
  const headers = { 'Content-Type': 'application/json' };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
};

const handleErrors = async (response, defaultMessage) => {
  if (response.ok) {
    return response.json();
  }
  const body = await response.json().catch(() => ({}));
  throw new Error(body.detail || body.message || defaultMessage || `Request failed (${response.status})`);
};

export async function fetchStandardRatioDefinitions() {
  const response = await fetch(`${API_BASE}/api/system/standard-ratios`, {
    headers: buildHeaders()
  });
  return handleErrors(response, 'Standart rasyo tanimlari alinamadi');
}

export async function createStandardRatioDefinition(data) {
  const response = await fetch(`${API_BASE}/api/system/standard-ratios`, {
    method: 'POST',
    headers: buildHeaders(),
    body: JSON.stringify(data)
  });
  return handleErrors(response, 'Standart rasyo tanimi olusturulamadi');
}

export async function updateStandardRatioDefinition(id, data) {
  const response = await fetch(`${API_BASE}/api/system/standard-ratios/${id}`, {
    method: 'PUT',
    headers: buildHeaders(),
    body: JSON.stringify(data)
  });
  return handleErrors(response, 'Standart rasyo tanimi guncellenemedi');
}

export async function deactivateStandardRatioDefinition(id) {
  const response = await fetch(`${API_BASE}/api/system/standard-ratios/${id}`, {
    method: 'DELETE',
    headers: buildHeaders()
  });
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body.detail || body.message || 'Standart rasyo tanimi pasif edilemedi');
  }
  return null;
}
